const indexItems = [
  { icon: 'ri-heart-pulse-line', label: '浪漫爱情', count: '186部', color: 'text-primary-500 bg-primary-50' },
  { icon: 'ri-home-heart-line', label: '婚姻家庭', count: '94部', color: 'text-accent-500 bg-accent-50' },
  { icon: 'ri-emotion-happy-line', label: '情侣喜剧', count: '73部', color: 'text-secondary-500 bg-secondary-50' },
  { icon: 'ri-star-smile-line', label: '高分经典', count: '128部', color: 'text-accent-600 bg-accent-50' },
  { icon: 'ri-fire-line', label: '新片速递', count: '42部', color: 'text-primary-600 bg-primary-50' },
  { icon: 'ri-global-line', label: '海外精选', count: '105部', color: 'text-secondary-600 bg-secondary-50' },
  { icon: 'ri-movie-2-line', label: '华语佳作', count: '156部', color: 'text-primary-500 bg-primary-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            分类导航
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            主题索引
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            按题材快速找到适合你们的夫妻电影与二人世界电影
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#"
              className="group flex flex-col items-center gap-3 bg-background-100 border border-background-200/70 hover:border-primary-300/60 rounded-xl p-5 md:p-6 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color} group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-2.5 py-0.5 rounded-full whitespace-nowrap">{item.count}</span>
            </a>
          ))}
          <a
            href="#"
            className="group flex flex-col items-center justify-center gap-2 bg-background-100 border border-dashed border-background-300/60 hover:border-primary-300/60 rounded-xl p-5 md:p-6 transition-all duration-300 cursor-pointer no-underline"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 group-hover:text-primary-500 transition-colors">
              <i className="ri-more-line text-lg"></i>
            </div>
            <span className="text-xs text-foreground-400 whitespace-nowrap">更多分类</span>
          </a>
        </div>
      </div>
    </section>
  );
}